__turbopack_context__.v({
  "facet": "facet-component-module-scss-module__iEy2Oq__facet",
  "facet--expanded": "facet-component-module-scss-module__iEy2Oq__facet--expanded",
  "facet__brand-searchbar": "facet-component-module-scss-module__iEy2Oq__facet__brand-searchbar",
  "facet__facet-button": "facet-component-module-scss-module__iEy2Oq__facet__facet-button",
  "facet__facet-button-arrow": "facet-component-module-scss-module__iEy2Oq__facet__facet-button-arrow",
  "facet__facet-content": "facet-component-module-scss-module__iEy2Oq__facet__facet-content",
  "facet__facet-list": "facet-component-module-scss-module__iEy2Oq__facet__facet-list",
  "facet__facet-option": "facet-component-module-scss-module__iEy2Oq__facet__facet-option",
  "facet__facet-option-label": "facet-component-module-scss-module__iEy2Oq__facet__facet-option-label",
  "facet__facet-option-label--selected": "facet-component-module-scss-module__iEy2Oq__facet__facet-option-label--selected",
  "facet__search-icon": "facet-component-module-scss-module__iEy2Oq__facet__search-icon",
  "facet__search-input": "facet-component-module-scss-module__iEy2Oq__facet__search-input",
});
